<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="700">
    <template v-slot:title>{{ editorTitle }}</template>
    <v-alert outlined type="info">{{
      value ? value.description : "Form description"
    }}</v-alert>
    <v-row v-if="value && value.isPaymentAmountRequired">
      <v-col
        ><v-text-field
          label="Amount"
          v-model="amount"
          :outlined="outlinedInputs"
      /></v-col>
    </v-row>
    <v-row v-if="linkURL != ''">
      <v-container pb-0>
        <v-textarea v-model="linkURL" ref="textToCopy" outlined></v-textarea>
      </v-container>
      <v-row align="center" justify="center">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mx-2"
              fab
              dark
              color="cyan"
              v-bind="attrs"
              v-on="on"
              @click="copyLink"
            >
              <v-icon dark>mdi-content-copy </v-icon>
            </v-btn>
          </template>
          <span>Copy To Clipboard</span>
        </v-tooltip>
      </v-row>
    </v-row>
    <template v-slot:actions>
      <v-btn
        v-if="showAttachLink && linkURL != ''"
        color="primary"
        @click="onAttachLink"
        :disabled="!isValid"
        :loading="loading"
        >Attach Link</v-btn
      >
      <v-btn
        color="primary"
        @click="onGenerateLink"
        :disabled="!isValid"
        :loading="loading"
        >Generate Link</v-btn
      >
    </template>

    <v-row v-if="debug">
      <v-col
        ><code>{{ value }}</code></v-col
      >
    </v-row>
  </basic-dialog>
</template>

<script>
import gql from "graphql-tag";
import BasicDialog from "../BasicDialog.vue";
const GENERATE_LINK_MUTATION = gql`
  mutation generateLink(
    $itineraryId: ID
    $paymentAmount: Float
    $code: String!
  ) {
    generateExternalFormLink(
      linkCode: $code
      itineraryId: $itineraryId
      paymentAmount: $paymentAmount
    ) {
      success
      message
      url
    }
  }
`;
export default {
  name: "external-form-dialog",

  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: Object,
      default: () => null,
    },
    itinerary: {
      type: Object,
      default: () => null,
    },
    showAttachLink: {
      type: Boolean,
      default: () => false,
    },
  },

  components: { BasicDialog },

  data() {
    return {
      debug: false,
      amount: 0,
      linkURL: "",
      loading: false,
    };
  },

  computed: {
    editorTitle() {
      return this.value ? this.value.name : `External Form`;
    },
    isValid() {
      return true;
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
  },

  watch: {
    value(newVal) {
      this.linkURL = "";
    },
  },

  methods: {
    copyLink() {
      const textToCopy = this.$refs.textToCopy.$el.querySelector("textarea");
      textToCopy.select();
      document.execCommand("copy");
    },
    onAttachLink() {
      this.$emit("attachLink", this.linkURL);
    },
    onGenerateLink() {
      this.loading = true;
      this.$apollo
        .mutate({
          mutation: GENERATE_LINK_MUTATION,
          variables: {
            paymentAmount: Number(this.amount),
            itineraryId: this.itinerary ? this.itinerary.id : "",
            code: this.value.code,
          },
        })
        .then(({ data }) => {
          if (data.generateExternalFormLink.success) {
            this.linkURL = data.generateExternalFormLink.url;
          } else {
            this.$store.dispatch("showAppSnackbar", {
              msg: data.generateExternalFormLink.message,
              color: "error",
            });
          }
          this.loading = false;
        })
        .catch((err) => {
          const errorMsg = err.graphQLErrors.map((e) => e.message).join(", ");
          this.$store.dispatch("showAppSnackbar", {
            msg: errorMsg,
            color: "error",
          });
          this.loading = false;
        });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/shared/external-forms/ExternalFormDialog.vue